import { AxiosInstance } from "axios";
import axios from "axios";
import { groupBy } from "lodash";

import * as moment from "moment";
import { defaultFilters } from "src/views/Links/services/filters";
import createQuery from "./utils/createQuery";
import { IParameter } from "src/views/Links/types";

interface IArgs {
  archiveFilters: string[];
  marketFilter: any;
}

let cache: any = null;

const queryFilters = defaultFilters;
queryFilters.dateFrom = moment("2010-01-01").toDate();
const query = createQuery(queryFilters);
query.aggs = {
  parameters: {
    nested: {
      path: "parameters",
    },
    aggs: {
      by_name: {
        terms: {
          field: "parameters.Name",
          size: 0,
        },
        aggs: {
          values: {
            terms: {
              field: "parameters.Value",
              size: 0,
              order: [
                {
                  _term: "asc",
                },
              ],
            },
          },
        },
      },
    },
  },
};

const toResponse = (response: any, { archiveFilters, marketFilter }: IArgs) => {
  if (!response.success || !response.result) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${response.errorMessage}`
    );
  }

  const filters =
    response.result.aggregations && response.result.aggregations.parameters
      ? response.result.aggregations.parameters.by_name.buckets.map(
          (el: any) => {
            return {
              name: el.key,
              values: el.values.buckets.map((v: any) => ({
                value: v.key,
                label: v.key,
              })),
            };
          }
        )
      : [];

  const allParameters = groupBy(filters, (parameter) =>
    archiveFilters.find((el) => el === parameter.name)
      ? "visibleParameters"
      : "extendedParameters"
  );

  const visibleParameters = allParameters.visibleParameters || [];
  const extendedParameters = allParameters.extendedParameters || [];
  if (marketFilter.values.length > 0) {
    visibleParameters.unshift(marketFilter);
  }

  cache = { parameters: visibleParameters, extendedParameters };

  return cache;
};

export const clearLinkFiltersCache = () => {
  cache = null;
};
export default (api: AxiosInstance, url: string) => (args: IArgs) => {
  const cancel = axios.CancelToken;
  const source = cancel.source();
  return {
    getData: async (): Promise<{
      parameters: IParameter[];
      extendedParameters: IParameter[];
    }> => {
      if (cache) {
        return cache;
      }
      const response = await api.post(url, query, {
        cancelToken: source.token,
      });
      if (!response) {
        return Promise.reject();
      }
      return toResponse(response.data, args);
    },
    cancel: source.cancel,
  };
};



// WEBPACK FOOTER //
// ./src/services/api/links/getFilters.ts